// extracted by mini-css-extract-plugin
export var bigText = "YtzC_";
export var container = "XyuIi";
export var contentContainer = "gqdUO";
export var dismissButtonContainer = "Qsp8R";
export var iconColumn = "E3izA";
export var nudgeBar = "zeokq";
export var smallText = "LCpDt";
export var textColumn = "uiVCk";
export var textContent = "Qrjn_";